import {
    GET_DATA_FAIL,
    GET_DATA_SUCCESS,
    GET_DATA_START,
    GET_QUARTER_DATA_START,
    GET_QUARTER_DATA_SUCCESS,
    GET_QUARTER_CHART_START,
    GET_QUARTER_CHART_SUCCESS,
    GET_QUARTER_DSP_CHART_START,
    GET_QUARTER_DSP_CHART_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_START,
    GET_QUARTER_TERRITORY_CHART_SUCCESS,
    GET_ASSET_PROFILE_START,
    GET_ASSET_PROFILE_SUCCESS,
    GET_TOPS_QUARTER_START,
    GET_TOPS_QUARTER_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS,
    GET_ISRC_DSP_CHART_START,
    GET_ISRC_DSP_CHART_SUCESS,

    GET_ISRC_CHART_DATE_START,
    GET_ISRC_CHART_DATE_SUCESS,
    GET_QUARTER_ACTIVITY_CHART_START,
    GET_QUARTER_ACTIVITY_CHART_SUCCESS,
    GET_IMPERSONATION_LIST_START,
    GET_IMPERSONATION_LIST_SUCCESS,
    SET_IMPERSONATION_LIST_START,
    SET_IMPERSONATION_LIST_SUCCESS,
    GET_LIVE_CHART_DATE_START,
    GET_LIVE_CHART_DATE_SUCESS,
    GET_LIVE_DATA_ISRC,
    GET_LIVE_DATA_ISRC_SUCCESS,
    SET_UNIT_TYPE,

    GET_CURRENT_RECIPIENT,
    GET_CURRENT_RECIPIENT_SUCCESS,
    SET_LOGIN_START,
    SET_LOGIN_SUCCESS,
    SET_EMAIL_START,
    SET_EMAIL_SUCCESS,
    GET_GROWTH_CHART,
    GET_GROWTH_CHART_SUCCESS,
    SET_AUDIOURL,
    GET_PRODUCT_PROFILE_START,
    GET_PRODUCT_PROFILE_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_SUCESS,
    GET_UPC_DSP_CHART_START,
    GET_UPC_DSP_CHART_SUCESS,
    GET_UPC_CHART_DATE_START,
    GET_UPC_CHART_DATE_SUCESS,
    GET_ASSETS_FROM_UPC_START,
    GET_ASSETS_FROM_UPC_SUCESS,
    GET_PRODUCTS_FROM_ISRC_SUCESS,
    GET_PRODUCTS_FROM_ISRC_START,
    GET_TOPS_MONTH,
    GET_TOPS_MONTH_SUCCESS,
    GET_CATALOGUE_PROFILE_START,
    GET_CATALOGUE_PROFILE_SUCCESS,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_START,
    GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_SUCESS,
    GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_START,
    GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_SUCESS,
    GET_CATALOGUE_DSP_CHART_START,
    GET_CATALOGUE_DSP_CHART_SUCESS,
    GET_CATALOGUE_CHART_DATE_START,
    GET_CATALOGUE_CHART_DATE_SUCESS,
    GET_ASSETS_FROM_CATALOGUE_START,
    GET_ASSETS_FROM_CATALOGUE_SUCESS,
    GET_CATALOGUES_START,
    GET_CATALOGUES_SUCCESS,
    GET_PRODUCTS_START,    
    GET_PRODUCTS_SUCCESS,
    GET_PRODUCT_TOTALS,
    GET_PRODUCT_TOTALS_SUCCESS,
    GET_ASSET_TOTALS,
    GET_ASSET_TOTALS_SUCCESS,
    GET_CATALOGUE_TOTALS,
    GET_CATALOGUE_TOTALS_SUCCESS,
    SET_ARTIST_SEARCH,
    SET_TITLE_SEARCH,
    GET_CATALOGUES_SEARCH_START,
    GET_CATALOGUES_SEARCH_SUCCESS,
    GET_GENRES_START,
    GET_GENRES_SUCCESS,
    SET_GENRES_SEARCH,
    SET_CATALOGUES_SEARCH,
    SET_ISRC_SEARCH,
    GET_SEARCH_DATA,
    GET_SEARCH_SUCCESS,
} from '../Types';


const INITIAL_STATE = {
    register_error: '',
    user: null,
    isLogin: null,
    login_error: '',
    summary: null,
    quarterList: null,
    selectedQuarter: "",
    quarterChart: null,
    dspQuarter: "",
    dspQuarterChart: null,
    territoryQuarter: "",
    territoryQuarterChart: null,
    requestedISRC: "",
    assetData: null,
    isLoadingAsset: true,
    topsQuarter: "",
    topsQuarterData: null,
    territoryStreams: null,
    territoryStreamsQuarter: "",
    territoryDownloads: null,
    territoryDownloadsQuarter: "",
    territoryDownloadsIsrc: "",
    territoryStreamsIsrc: "",
    territoryDownloadsIsrcData: null,
    territoryStreamsIsrcData: null,
    dspISRC: "",
    dspISRCData: null,
    chartIsrc: "",
    chartIsrcType: "",
    chartIsrcStartMonth: null,
    chartIsrcStartYear: null,
    chartIsrcEndYear: null,
    chartIsrcEndMonth: null,
    chartIsrcActivity: null,
    activityQuarter: "",
    activityChart: null,
    recipientList: null,
    recipientListLoading: false,
    recipientID: "",
    recipientSaving: false,
    liveStreamData: null,
    isloadingLiveData: false,
    isloadingLiveDataIsrcDownload: false,
    isloadingLiveDataIsrcStream: false,
    liveDataISRCrequested: "",
    liveDataISRCunitTypeRequested: "",
    liveDataISRCChartStream: null,
    liveDataISRCChartDownload: null,
    liveDataISRCstartDate: "",
    liveDataISRCendDate: "",
    unitType: "streams",
    currentRecipientImper: null,
    recipientLoginSaving: false,
    recipientLoginID: "",
    recipientEmailID: "",
    recipientEmailSaving: false,
    isloadingKPI: false,
    growthTable: [],
    growthMonth: 0,
    growthYear: 0,
    audioURL: "",
    requestedUPC: "",
    productData: null,
    isLoadingProduct: false,
    territoryDownloadsUPC: "",
    territoryDownloadsUPCData: null,
    territoryStreamsUPC: "",
    territoryStreamsUPCData: null,
    dspUPC: "",
    dspUPCData: "",
    chartUPC: "",
    chartUPCType: "",
    chartUPCStartMonth: null,
    chartUPCStartYear: null,
    chartUPCEndYear: null,
    chartUPCEndMonth: null,
    chartUPCActivity: null,
    assetUPC: "",
    assetsInUPC: null,
    productsISRC: "",
    productsInISRC: null,
    topsMonth: "",
    topsYear: "",
    topsType: "",
    listTopsProducts: null,
    listTopsAssets: null,
    catalogueData: null,
    requestedCAT: "",
    isLoadingCatalogue: false,
    territoryDownloadsCatalogue: "",
    territoryDownloadsCatalogueData: null,
    territoryStreamsCatalogue: "",
    territoryStreamsCatalogueData: null,
    dspCatalogue: "",
    dspCatalogueData: "",
    chartCatalogue: "",
    chartCatalogueType: "",
    chartCatalogueStartMonth: null,
    chartCatalogueStartYear: null,
    chartCatalogueEndYear: null,
    chartCatalogueEndMonth: null,
    chartCatalogueActivity: null,
    catalogueList: null,
    isLoadingCatalogueList: false,
    productsList: null,
    isLoadingProductList: false,
    audioMeta: "",
    topAssetsLoading: false,
    topProductsLoading: false,
    productTotalscode: "",
    productTotals: null,
    assetTotalscode: "",
    assetTotals: null,
    catalogueTotalscode: "",
    catalogueTotals: null,
    assetArtist: null,
    assetTitle: null,
    cataloguesSearch: null,
    genres: null,
    isLoadingGenres: false,
    isLoadingCataloguesSearch: false,
    selectedGenres: null,
    selectedSearchCatalogue: null,
    isrcSearch: "",
    filterSelected: {
        author: null, title: null, catalogs: null, genres: null, isrc: ""
    },
    requestedFilter: null,
    isLoadingSearch: false,



}

export default (state = INITIAL_STATE, action) => {
    let filter = Object.assign({}, state.filterSelected);
    switch (action.type) {
        case GET_SEARCH_DATA:
            return {
                ...state,
                isLoadingSearch: true,
                quarterList: null,
                requestedFilter: action.nameQuery
            }
        case GET_SEARCH_SUCCESS:
            return {
                ...state,
                isLoadingSearch: false,
                quarterList: action.data,
                requestedFilter: action.nameQuery,
                filterSelected: {
                    author: null, title: null, catalogs: null, genres: null, isrc: ""
                },
                assetArtist: null,
                assetTitle: null,
                selectedSearchCatalogue: null,
                selectedGenres: null,
                isrcSearch: ""

            }


        case SET_TITLE_SEARCH:
            filter.title = action.data;
            return {
                ...state,
                assetTitle: action.data,
                 filterSelected: filter
            }
        case SET_ARTIST_SEARCH:
            filter.author = action.data;
            return {
                ...state,
                assetArtist: action.data,
                 filterSelected: filter
            }
        case SET_ISRC_SEARCH:           
            filter.isrc = action.data
            return {
                ...state,
                isrcSearch: action.data,
                filterSelected: filter
            }
        case SET_GENRES_SEARCH:           
            filter.genres = action.data
            return {
                ...state,
                selectedGenres: action.data,
                 filterSelected: filter
            }
        case SET_CATALOGUES_SEARCH:
            filter.catalogs = action.data
            return {
                ...state,
                selectedSearchCatalogue: action.data,
                filterSelected: filter
            }
        case GET_CATALOGUES_SEARCH_START:
            return {
                ...state,
                cataloguesSearch: [],
                isLoadingCataloguesSearch: true,
            }
        case GET_CATALOGUES_SEARCH_SUCCESS:
            return {
                ...state,
                cataloguesSearch: action.payload,
                isLoadingCataloguesSearch: false,
            }
        case GET_GENRES_START:
            return {
                ...state,
                genres: [],
                isLoadingGenres: true,
            }
        case GET_GENRES_SUCCESS:         
            return {
                ...state,
                genres: action.payload,
                isLoadingGenres: false,
            }
       
        case GET_ASSET_TOTALS:
            return {
                ...state,
                assetTotalscode: action.code,
                assetTotals: null
            }
        case GET_ASSET_TOTALS_SUCCESS:
            return {
                ...state,
                assetTotalscode: action.code,
                assetTotals: action.payload
            }
        case GET_PRODUCT_TOTALS:
            return {
                ...state,
                productTotalscode: action.code,
                productTotals: null
            }
        case GET_PRODUCT_TOTALS_SUCCESS:
            return {
                ...state,
                productTotalscode: action.code,
                productTotals: action.payload
            }
        case GET_CATALOGUE_TOTALS:
            return {
                ...state,
                catalogueTotalscode: action.code,
                catalogueTotals: null
            }
        case GET_CATALOGUE_TOTALS_SUCCESS:
            return {
                ...state,
                catalogueTotalscode: action.code,
                catalogueTotals: action.payload
            }
        case GET_PRODUCTS_START:
            return {
                ...state,
                productsList: null,
                isLoadingProductList: true,
            }
        case GET_PRODUCTS_SUCCESS:
            return {
                ...state,
                productsList: action.payload,
                isLoadingProductList: true,
            }
        case GET_CATALOGUES_START:
            return {
                ...state,
                catalogueList: null,
                isLoadingCatalogueList: true,
            }
        case GET_CATALOGUES_SUCCESS:
            return {
                ...state,
                catalogueList: action.payload,
                isLoadingCatalogueList: true,
            }

        case GET_ASSETS_FROM_CATALOGUE_START:
            return {
                ...state,
                assetsInCatalogue: null,
                assetCatalogue: action.Catalogue
            }
        case GET_ASSETS_FROM_CATALOGUE_SUCESS:
            return {
                ...state,
                assetsInCatalogue: action.payload,
                assetCatalogue: action.Catalogue
            }
        case GET_CATALOGUE_CHART_DATE_START:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartCatalogue: action.Catalogue,
                        chartCatalogueType: action.chartType,
                        chartCatalogueStartMonth: action.startMonth,
                        chartCatalogueStartYear: action.startYear,
                        chartCatalogueEndYear: action.endYear,
                        chartCatalogueEndMonth: action.endMonth,
                        chartCatalogueActivity: null,
                    }
                default:
            }
            break;
        case GET_CATALOGUE_CHART_DATE_SUCESS:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartCatalogue: action.Catalogue,
                        chartCatalogueType: action.chartType,
                        chartCatalogueStartMonth: action.startMonth,
                        chartCatalogueStartYear: action.startYear,
                        chartCatalogueEndYear: action.endYear,
                        chartCatalogueEndMonth: action.endMonth,
                        chartCatalogueActivity: action.payload,
                    }
                default:
            }
            break;
        case GET_CATALOGUE_DSP_CHART_START:
            return {
                ...state,
                dspCatalogue: action.Catalogue,
                dspCatalogueData: null
            };
        case GET_CATALOGUE_DSP_CHART_SUCESS:
            return {
                ...state,
                dspCatalogueData: action.payload,
                dspCatalogue: action.Catalogue

            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_START:
            return {
                ...state,
                territoryStreamsCatalogue: action.Catalogue,
                territoryStreamsCatalogueData: null
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_CATALOGUE_SUCESS:
            return {
                ...state,
                territoryStreamsCatalogue: action.Catalogue,
                territoryStreamsCatalogueData: action.payload
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_START:
            return {
                ...state,
                territoryDownloadsCatalogue: action.Catalogue,
                territoryDownloadsCatalogueData: null
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_CATALOGUE_SUCESS:
            return {
                ...state,
                territoryDownloadsCatalogue: action.Catalogue,
                territoryDownloadsCatalogueData: action.payload
            }
        case GET_CATALOGUE_PROFILE_START:
            return {
                ...state,
                requestedCAT: action.catalogue,
                catalogueData: null,
                isLoadingCatalogue: true
            };
        case GET_CATALOGUE_PROFILE_SUCCESS:
            return {
                ...state,
                requestedCAT: action.catalogue,
                isLoadingCatalogue: false,
                catalogueData: action.payload
            }
        case GET_TOPS_MONTH:
            switch (action._type) {
                case "product":
                    return {
                        ...state,
                        topsMonth: action.month,
                        topsYear: action.year,
                        topsType: action._type,
                        listTopsProducts: null,
                        topProductsLoading: true

                    }
                   
                case "asset":
                    return {
                        ...state,
                        topsMonth: action.month,
                        topsYear: action.year,
                        topsType: action._type,
                        listTopsAssets: null,
                        topAssetsLoading: true
                    }
                   
                default: return {...state}
            }
        case GET_TOPS_MONTH_SUCCESS:
            switch (action._type) {
                case "product":
                    return {
                        ...state,
                        topsMonth: action.month,
                        topsYear: action.year,
                        topsType: action._type,
                        listTopsProducts: action.payload,
                        topProductsLoading: false

                    }
                    
                case "asset":
                    return {
                        ...state,
                        topsMonth: action.month,
                        topsYear: action.year,
                        topsType: action._type,
                        listTopsAssets: action.payload,
                        topAssetsLoading:false
                    }
                default: return { ...state}
            }
        case GET_PRODUCTS_FROM_ISRC_START:
            return {
                ...state,
                productsInISRC: null,
                productsISRC: action.isrc
            }
        case GET_PRODUCTS_FROM_ISRC_SUCESS:
            return {
                ...state,
                productsInISRC: action.payload,
                productsISRC: action.isrc
            }
        case GET_ASSETS_FROM_UPC_START:
            return {
                ...state,
                assetsInUPC: null,
                assetUPC: action.upc
            }
        case GET_ASSETS_FROM_UPC_SUCESS:
            return {
                ...state,
                assetsInUPC: action.payload,
                assetUPC: action.upc
            }
        case GET_UPC_CHART_DATE_START:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartUPC: action.UPC,
                        chartUPCType: action.chartType,
                        chartUPCStartMonth: action.startMonth,
                        chartUPCStartYear: action.startYear,
                        chartUPCEndYear: action.endYear,
                        chartUPCEndMonth: action.endMonth,
                        chartUPCActivity: null,
                    }
                default:
            }
            break;
        case GET_UPC_CHART_DATE_SUCESS:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartUPC: action.UPC,
                        chartUPCType: action.chartType,
                        chartUPCStartMonth: action.startMonth,
                        chartUPCStartYear: action.startYear,
                        chartUPCEndYear: action.endYear,
                        chartUPCEndMonth: action.endMonth,
                        chartUPCActivity: action.payload,
                    }
                default:
            }
            break;
        case GET_UPC_DSP_CHART_START:
            return {
                ...state,
                dspUPC: action.upc,
                dspUPCData: null
            };
        case GET_UPC_DSP_CHART_SUCESS:
            return {
                ...state,
                dspUPCData: action.payload,
                dspUPC: action.upc

            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_START:
            return {
                ...state,
                territoryStreamsUPC: action.upc,
                territoryStreamsUPCData: null
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_UPC_SUCESS:
            return {
                ...state,
                territoryStreamsUPC: action.upc,
                territoryStreamsUPCData: action.payload
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_START:
            return {
                ...state,
                territoryDownloadsUPC: action.upc,
                territoryDownloadsUPCData: null
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_UPC_SUCESS:
            return {
                ...state,
                territoryDownloadsUPC: action.upc,
                territoryDownloadsUPCData: action.payload
            }
        case GET_PRODUCT_PROFILE_START:
            return {
                ...state,
                requestedUPC: action.upc,
                productData: null,
                isLoadingProduct: true
            };
        case GET_PRODUCT_PROFILE_SUCCESS:
            return {
                ...state,
                requestedUPC: action.upc,
                isLoadingProduct: false,
                productData: action.payload
            }
        case SET_AUDIOURL:
            return { ...state, audioURL: action.url , audioMeta: action.meta}
        case SET_UNIT_TYPE: {
            return {
                ...state,
                unitType: action.unit
            }

        }
        case GET_LIVE_DATA_ISRC:
            switch (action.unitType) {
                case "stream":
                    return {
                        ...state,
                        isloadingLiveDataIsrcStream: true,
                        liveDataISRCChartStream: null,
                        liveDataISRCstartDate: action.startDate,
                        liveDataISRCendDate: action.endDate,
                        liveDataISRCrequested: action.isrc
                    }
                case "download":
                    return {
                        ...state,
                        isloadingLiveDataIsrcDownload: true,
                        liveDataISRCChartDownload: null,
                        liveDataISRCstartDate: action.startDate,
                        liveDataISRCendDate: action.endDate,
                        liveDataISRCrequested: action.isrc
                    }
                default:
                    return { ...state }
            }
        case GET_LIVE_DATA_ISRC_SUCCESS:
            switch (action.unitType) {
                case "stream":
                    return {
                        ...state,
                        isloadingLiveDataIsrcStream: false,
                        liveDataISRCChartStream: action.payload,
                        liveDataISRCstartDate: action.startDate,
                        liveDataISRCendDate: action.endDate,
                        liveDataISRCrequested: action.isrc
                    }
                case "download":
                    return {
                        ...state,
                        isloadingLiveDataIsrcDownload: false,
                        liveDataISRCChartDownload: action.payload,
                        liveDataISRCstartDate: action.startDate,
                        liveDataISRCendDate: action.endDate,
                        liveDataISRCrequested: action.isrc
                    }
                default:
                    return { ...state }
            } 
        case GET_LIVE_CHART_DATE_START:
            return { ...state, isloadingLiveData: true };
        case GET_LIVE_CHART_DATE_SUCESS:
            return { ...state, isloadingLiveData: false, liveStreamData: action.payload }
        case GET_DATA_START:
            return { ...state, isLoading: true, login_error: '' };
        case GET_DATA_SUCCESS:
            return {
                ...state,
                isLogin: true,
                isLoading: false,
                summary: action.payload
            };
        case GET_QUARTER_DATA_START:
            return {
                ...state,
                isLoading: true,
                selectedQuarter: action.quarter,
                quarterList : null
            };
        case GET_QUARTER_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                selectedQuarter: action.quarter,
                quarterList: action.payload
            };
        case GET_QUARTER_CHART_START:
            return { ...state, isLoading: true };
        case GET_QUARTER_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                quarterChart: action.payload
            };
        case GET_QUARTER_DSP_CHART_START:
            return {
                ...state,
                dspQuarter: action.quarter,
                dspQuarterChart: null,
                isLoading: true
            };
        case GET_QUARTER_DSP_CHART_SUCCESS:
            return {
                ...state,
                dspQuarterChart: action.payload,
                isLoading: false,
                dspQuarter: action.quarter
                
            }
        case GET_QUARTER_TERRITORY_CHART_START:
            return {
                ...state,
                territoryQuarter: action.quarter,
                isLoading: true,
                territoryQuarterChart: null
            };
        case GET_QUARTER_TERRITORY_CHART_SUCCESS:
            return {
                ...state,
                territoryQuarterChart: action.payload,
                isLoading: false,
                territoryQuarter: action.quarter

            };
        case GET_ASSET_PROFILE_START:
            return {
                ...state,
                requestedISRC: action.isrc,
                assetData: null,
                isLoadingAsset: true
            };
        case GET_ASSET_PROFILE_SUCCESS:
            return{
                ...state,
                requestedISRC:action.isrc,
                isLoadingAsset: false,
                assetData: action.payload
            }
        case GET_TOPS_QUARTER_START:
            return {
                ...state,
                topsQuarter: action.quarter,
                topsQuarterData: null
            }
        case GET_TOPS_QUARTER_SUCCESS:
            return {
                ...state,
                topsQuarter: action.quarter,
                topsQuarterData: action.payload
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_START:
            return {
                ...state,
                territoryDownloads: null,
                territoryDownloadsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_SUCESS:
            return {
                ...state,
                territoryDownloads: action.payload,
                territoryDownloadsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_START:
            return {
                ...state,
                territoryStreams: null,
                territoryStreamsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_SUCESS:
            return {
                ...state,
                territoryStreams: action.payload,
                territoryStreamsQuarter: action.quarter
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_START:
            return {
                ...state,
                territoryStreamsIsrc: action.isrc,
                territoryStreamsIsrcData: null
            }
        case GET_QUARTER_TERRITORY_CHART_STREAMS_ISRC_SUCESS:
            return {
                ...state,
                territoryStreamsIsrc: action.isrc,
                territoryStreamsIsrcData: action.payload
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_START:
            return {
                ...state,
                territoryDownloadsIsrc: action.isrc,
                territoryDownloadsIsrcData: null
            }
        case GET_QUARTER_TERRITORY_CHART_DOWNLOADS_ISRC_SUCESS:
            return {
                ...state,
                territoryDownloadsIsrc: action.isrc,
                territoryDownloadsIsrcData: action.payload
            }
        case GET_ISRC_DSP_CHART_START:
            return {
                ...state,
                dspISRC: action.isrc,
                dspISRCData: null
            };
        case GET_ISRC_DSP_CHART_SUCESS:
            return {
                ...state,
                dspISRCData: action.payload,              
                dspISRC: action.isrc

            }
        case GET_ISRC_CHART_DATE_START:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartIsrc : action.isrc,
                        chartIsrcType: action.chartType,
                        chartIsrcStartMonth: action.startMonth,
                        chartIsrcStartYear: action.startYear,
                        chartIsrcEndYear: action.endYear,
                        chartIsrcEndMonth: action.endMonth,
                        chartIsrcActivity: null,
                    }
                default:
            }
            break;
        case GET_ISRC_CHART_DATE_SUCESS:
            switch (action.chartType) {
                case "activity":
                    return {
                        ...state,
                        chartIsrc: action.isrc,
                        chartIsrcType: action.chartType,
                        chartIsrcStartMonth: action.startMonth,
                        chartIsrcStartYear: action.startYear,
                        chartIsrcEndYear: action.endYear,
                        chartIsrcEndMonth: action.endMonth,
                        chartIsrcActivity: action.payload,
                    }
                default:
            }
            break;
        case GET_QUARTER_ACTIVITY_CHART_START:
            return {
                ...state,
                activityChart: null,
                activityQuarter : action.quarter
            };
        case GET_QUARTER_ACTIVITY_CHART_SUCCESS:
            return {
                ...state,
                activityChart: action.payload,
                activityQuarter: action.quarter
            }
        case GET_IMPERSONATION_LIST_START:
            return {
                ...state,
                 recipientListLoading: true,
               
            }
        case GET_IMPERSONATION_LIST_SUCCESS:
            return {
                ...state,
                recipientList: action.payload,
                recipientListLoading: false,

               
            }
        case SET_IMPERSONATION_LIST_START:
            return {
                ...state,
                recipientID: action.id,
                recipientListLoading: true,
                recipientList: null,
                recipientSaving:true
            }
        case SET_IMPERSONATION_LIST_SUCCESS:
            return {
                ...state,
                recipientID: action.id,
                recipientList: action.payload,
                recipientListLoading: false,
                recipientSaving: false,
                summary: null,
                quarterList: null,
                selectedQuarter: "",
                quarterChart: null,
                dspQuarter: "",
                dspQuarterChart: null,
                territoryQuarter: "",
                territoryQuarterChart: null,    
                topsQuarter: "",
                topsQuarterData: null,
                territoryStreams: null,
                territoryStreamsQuarter: "",
                territoryDownloads: null,
                territoryDownloadsQuarter: "",
                activityQuarter: "",
                activityChart: null,
                currentRecipientImper: action.payload.filter(t=>t.isImpersonating)[0]
                
            }
        case SET_LOGIN_START:
            return {
                ...state,
                recipientLoginSaving: true,
                recipientLoginID: action.id
            }
        case SET_LOGIN_SUCCESS:
            return {
                ...state,
                recipientLoginSaving: false,
                recipientLoginID: action.id,
                recipientList: action.payload,               

            }
        case SET_EMAIL_START:
            return {
                ...state,
                recipientEmailSaving: true,
                recipientEmailID: action.id
            }
        case SET_EMAIL_SUCCESS:
          
            return {
                ...state,
                recipientEmailSaving: false,
                recipientEmailID: action.id,
                recipientList:  action.payload,

            }


        case GET_CURRENT_RECIPIENT:
            return {
                ...state
            }
        case GET_CURRENT_RECIPIENT_SUCCESS:
            return {
                ...state,
                currentRecipientImper: action.payload
            }
        case GET_GROWTH_CHART:
            return {
                ...state,
                isloadingKPI: true,
                growthTable: [],
                growthMonth: action.month,
                growthYear: action.year
            }
        case GET_GROWTH_CHART_SUCCESS:
            return {
                ...state,
                isloadingKPI: false,
                growthTable: action.payload,
                growthMonth: action.month,
                growthYear: action.year
            }
        
       
        default: return state;

    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/dataReducer.js